
import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
}

const GlassCard: React.FC<GlassCardProps> = ({ children, className }) => {
  return (
    <div
      className={`bg-white/70 backdrop-blur-lg border border-slate-200/50 rounded-xl shadow-lg p-6 md:p-8 ${className || ''}`}
    >
      {children}
    </div>
  );
};

export default GlassCard;
